import { HeaderLogo } from 'components/Layout/Header/HeaderLogo';
import { SgwtAccountCenter } from 'components/Layout/Header/SgwtAccountCenter';
import React, { FC } from 'react';
import { LanguageSelector } from '../Language/LanguageSelector';

export const Header: FC = () => {
    return <header className="sticky-top bg-lvl1">
        <nav className="navbar">
            <div className="navbar-title">
                <HeaderLogo />
            </div>

            <div className="navbar-content">
                <div className="d-block d-flex flex-grow-1 mx-3 justify-content-end ">
                    <LanguageSelector />
                    <SgwtAccountCenter />
                </div>
            </div>
        </nav>
    </header>;
};
